export enum FileType {
    any,
    image,
    video,
    audio,
    others
}

export enum FileCategory {
    normal,
    feature,
    original
}

export const createEditPictureModel = (initial?: PictureModel): EditPictureModel => {
    if (initial) {
        return initial;
    }

    return {
        id: 0,
        category: FileCategory.normal,
        type: FileType.image,
        isPrimary: false,
        order: 1,
        collageOrder: 1,
        length: 0,
        imageUrl: undefined
    };
};

export interface EditPictureModel {
    id: number;
    category: FileCategory;
    type: FileType;
    isPrimary: boolean;
    order: number;
    collageOrder: number;
    length: number;
    imageUrl: any;
}

export interface UploadPictureModel extends EditPictureModel {
    file?: any;
    bytes?: any;
}

export interface PictureModel extends EditPictureModel {
    fileName: string;
    filePath: string;
    content: string;
}

export class PictureOrderModel {
    public id: number = 0;
    public order: number = 0;
}